﻿import React from 'react'
import classNames from "classnames";
import {
  ButtonDropdownItem,
  ButtonDropdownProvider,
  ButtonSplitDropdownItem,
  ButtonSplitDropdownProvider
} from '../buttons';
import { FileDownloadFormats } from './Types';
import styles from "../labels/Label.scss";

export interface SaveAndDownloadProps {
  className?: string;
  readOnly: boolean;
  additionalDownloadButtons?: ButtonDropdownItem[];
  onPrint?: (format: FileDownloadFormats) => any;
  onSave?: (exit: boolean) => any;
}

export const SaveAndDownload: React.FC<SaveAndDownloadProps> = (props) => {

  const getPrintItems=()=>{
   let printItems:ButtonDropdownItem[]  = [
    {
      label: "PDF",
      value() {
        props.onPrint && props.onPrint(FileDownloadFormats.Pdf);
      },
    },
    {
      label: "MS Word",
      value() {
        props.onPrint && props.onPrint(FileDownloadFormats.Word);
      },
    },
  ];
  props.additionalDownloadButtons && printItems.push(...props.additionalDownloadButtons);
  return printItems;
}

  const saveItems: ButtonSplitDropdownItem[] = [
    {
      label: "Save and Exit",
      onDrodownButtonClick() {
        props.onSave && props.onSave(true);
      },
    },
  ];

  return <div
    className={classNames("row", "justify-content-center", "mt-2", props.className)}
    style={{display: props.onPrint || props.onSave ? undefined : "none"}}
  >
    <div className="col-auto">
      <div className={styles["acs-dropdown-button"]}>
        {props.onPrint && <ButtonDropdownProvider
          items={getPrintItems()}
          label="Download"
        />}
        {!props.readOnly && props.onSave && (
          <ButtonSplitDropdownProvider
            className="ml-3 mr-0"
            items={saveItems}
            label="Save"
            onButtonClick={() => props.onSave && props.onSave(false)}
          />
        )}
      </div>
    </div>
  </div>
}